module.exports = __webpack_public_path__ + "assets/img/hit-animation.ae38da1c.png";